/*global define: false */
define('search',['jquery'], function ($) {
    'use strict';

    $('body').on('click', '.site-search .clear-button', function () {
        $('.site-search  input').val('');
    });
});
